import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Index from '@/views/program/Index';
import ProgramList from '@/views/program/ProgramList'
import Program from '@/views/program/Program'
import PDFGlobal from '@/views/report/App'

export default {
  path: 'programs',
  component: Index,
  name: 'programs',
  beforeEnter: multiguard([ middleware.hasPlan, middleware.isNotSuperImpact ]),
  children: [
    {
      path: 'list',
      component: ProgramList,
      name: 'program-list',
      meta: { title: 'My programs' },
      // children: [
      //   {
      //     path: ':programId',
      //     component: FarmDashboard,
      //     name : 'program',
      //   },
      // ]
      children: [
        {
          path: ':idList',
          component: ProgramList,
          meta: { title: 'My programs' },
          // name : 'program',
        },
      ]
    },
    {
      path: ':programId',
      component: Program,
      name: 'program',
      meta: { title: 'Program' },
    },
    {
      path: 'new',
      component: Program,
      name: 'new-program',
      meta: { title: 'Add program' },
    }
  ]
};
